export class Icons {
  static readonly ADMIN = 'cog';
  static readonly BATCH_PAYMENT = 'bank';
  static readonly BATCH_PAYMENT_SUGGESTION = 'calendar-range';
  static readonly BATCH_PAYMENT_VALIDATION = 'bookmark-check';
  static readonly BENEFICIARY = 'human-female';
  static readonly BENEFICIARY_GROUP = 'account-supervisor';
  static readonly DASHBOARD = 'view-dashboard-variant';
  static readonly DONATION = 'hand-heart';
  static readonly LOGOUT = 'run';
  static readonly LOCAL_PARTNER = 'account-supervisor-circle';
  static readonly MONEYBAR = 'gauge';
  static readonly ORGANISATION = 'domain';
  static readonly QUESTIONNAIRE = 'script-text-outline';
  static readonly QUESTION = 'frequently-asked-questions';
  static readonly QUESTION_CATEGORY = 'animation-outline';
  static readonly SURVEY = 'clipboard-list';
  static readonly TASK_DEFINITION = 'calendar-clock';
  static readonly TASK_EXECUTION = 'calendar-text-outline';
  static readonly USER = 'account';
  static readonly USERS = 'account-multiple-outline';
  static readonly WORKFLOW_TASK = 'clipboard-check';

  // Actions
  static readonly DELETE = 'delete';
  static readonly WAIT = 'timer-sand-empty';
}
